import Marionette from "backbone.marionette";

const DEFAULTS = {
  className: "ajax-loader",
  template: _.template('<div class="loading-indicator"></div>'),
};

class View extends Marionette.ItemView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }
}

export { View as default };
